import { render, staticRenderFns } from "./edit-consume.vue?vue&type=template&id=318a0c49&scoped=true"
import script from "./edit-consume.ts?vue&type=script&lang=ts&external"
export * from "./edit-consume.ts?vue&type=script&lang=ts&external"
import style0 from "./edit-consume.scoped.scss?vue&type=style&index=0&id=318a0c49&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318a0c49",
  null
  
)

export default component.exports